import styled from '@emotion/styled';
import React from 'react';

export interface AspectRatioProps extends React.HTMLAttributes<HTMLDivElement> {
  ratio: number;
  innerClassName?: string;
}

const Outer = styled.div<AspectRatioProps>`
  position: relative;

  ::before {
    content: '';
    display: block;
    padding-bottom: ${({ ratio }) => 100 / ratio}%;
  }
`;

const Inner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

function AspectRatio({ innerClassName, children, ...rest }: AspectRatioProps) {
  return (
    <Outer {...rest}>
      <Inner className={innerClassName}>{children}</Inner>
    </Outer>
  );
}

export default AspectRatio;
